// K2-3073: who hides the loader once an order is placed. order/placeOrder keeps
// its 'Processing order...' loader on through 'order-after-placed' so a
// listener that goes on with the order (a payment) can keep it showing; the
// listener that takes it over stops it on every exit. With no such listener,
// placeOrder stops it itself.

interface Bus {
  $emit (event: string, ...args: any[]): any
}

export function emitOrderAfterPlaced (bus: Bus, payload: any): void {
  bus.$emit('order-after-placed', payload)
  if (!payload.progressHandled) {
    bus.$emit('notification-progress-stop')
  }
}

/**
 * Runs an 'order-after-placed' listener that answers for the loader: claims it
 * at once (before placeOrder checks) and stops it when run settles or throws -
 * unless run resolves while leavingPage() (a 3DS redirect), when the loader
 * stays on until the page goes.
 */
export async function handleOrderProgress<T> (bus: Bus, payload: any, run: () => Promise<T>, leavingPage: () => boolean = () => false): Promise<T> {
  if (payload && typeof payload === 'object') {
    payload.progressHandled = true
  }
  let keep = false
  try {
    const result = await run()
    keep = leavingPage()
    return result
  } finally {
    if (!keep) {
      bus.$emit('notification-progress-stop')
    }
  }
}
